// translations/pages/teaching/de.js
export const teachingPageDE = {
  hero: {
    title: 'Edge-KI & EU AI Act Training',
    subtitle: 'Enterprise-KI Beratung • Edge-Entwicklung • Rechtssichere Implementierung'
  },
  intro: 'Spezialisierte KI-Schulungen für Geschäftsleitung, Projektleiter und Entwicklungsteams. Von strategischer Beratung bis technischer Implementierung - EU AI Act konform.',
  
  // Neue EU AI Act Sektion
  eu_ai_act: {
    title: 'EU AI Act Compliance & Edge Computing',
    subtitle: 'Rechtssichere KI-Implementierung mit lokaler Datenverarbeitung',
    description: 'Der EU AI Act definiert strenge Regeln für den Einsatz künstlicher Intelligenz in Europa. Edge Computing bietet die ideale Lösung: Sensible Daten bleiben lokal, Compliance wird vereinfacht und die Kontrolle über KI-Systeme bleibt in Ihren Händen.',
    benefits: [
      'Datenschutz durch lokale Verarbeitung',
      'Reduzierte Compliance-Komplexität',
      'Volle Kontrolle über KI-Entscheidungen',
      'Transparenz und Nachvollziehbarkeit',
      'Minimierte rechtliche Risiken',
      'Unabhängigkeit von Cloud-Anbietern'
    ],
    highlight: 'Edge Computing + EU AI Act = Rechtssichere KI ohne Kompromisse'
  },
  
  offerings: {
    title: 'Lehrangebot',
    categories: [
      {
        title: 'Künstliche Intelligenz & Machine Learning',
        icon: 'brain',
        topics: [
          'Generative KI & Large Language Models (Edge & Cloud)',
          'Klassisches Machine Learning (Edge-optimiert)',
          'Deep Learning & Neural Networks (Edge Deployment)',
          'Computer Vision & NLP (Edge-fähige Lösungen)',
          'RAG-Systeme & LLM Fine-Tuning (Edge & Cloud)',
          'Autonome KI-Agenten (Edge Computing)',
          'EU AI Act Compliance & Rechtssicherheit'
        ]
      },
      {
        title: 'Data Science & Statistik',
        icon: 'chart',
        topics: [
          'Deskriptive & Inferentielle Statistik',
          'Datenmodellierung & -analyse',
          'Zeitreihenanalyse',
          'Ökonometrie für BWL/VWL',
          'Biostatistik für Naturwissenschaften',
          'A/B Testing & Experimentdesign'
        ]
      },
      {
        title: 'Software-Architektur & Sicherheit',
        icon: 'shield',
        topics: [
          'Modulare Architekturen',
          'Loose Coupling & Clean Code',
          'Microservices Design',
          'IT-Sicherheit & Compliance',
          'DevOps & CI/CD',
          'Cloud-Architekturen'
        ]
      }
    ]
  },

  target_groups: {
    title: 'Zielgruppen',
    groups: [
      {
        title: 'Geschäftsleitung & Entscheider',
        description: 'Strategische KI-Beratung, Kostenanalyse und Investitionsentscheidungen',
        formats: ['Executive Briefings', 'ROI-Analysen', 'Strategieberatung'],
        focus: 'Business Cases, EU AI Act Compliance, Budgetplanung'
      },
      {
        title: 'Projektleiter & Manager',
        description: 'KI-Projektmanagement, Technologieauswahl und Implementierungsstrategien',
        formats: ['Management Workshops', 'Technologie-Assessments', 'Roadmap-Entwicklung'],
        focus: 'Projektplanung, Vendor-Selection, Risk Management'
      },
      {
        title: 'IT-Entwickler & Engineers',
        description: 'Hands-on Edge-KI Entwicklung, technische Implementierung und Deployment',
        formats: ['Technical Deep Dives', 'Code Reviews', 'Architecture Workshops'],
        focus: 'Edge Computing, LLM Fine-Tuning, System Integration'
      },
      {
        title: 'Fachbereichsmitarbeiter',
        description: 'KI-Verständnis, Prompting-Techniken und praktische Anwendung im Arbeitsalltag',
        formats: ['User Training', 'Prompting Workshops', 'Use Case Development'],
        focus: 'Praktische Anwendung, Workflow-Integration, Produktivitätssteigerung'
      },
      {
        title: 'Studierende & Akademiker',
        description: 'Universitäre Lehre, Nachhilfe und wissenschaftliche Projektbetreuung',
        formats: ['Vorlesungen', 'Tutoring', 'Thesis-Betreuung'],
        focus: 'Statistik, Ökonometrie, Forschungsmethoden'
      }
    ]
  },

  expertise: {
    title: 'Technische Expertise',
    items: [
      'Strategische KI-Roadmap-Entwicklung für Unternehmen',
      'Edge-KI-Systeme mit RAG/GRAG-Architekturen und LoRA/QLoRA Fine-Tuning',
      'EU AI Act Compliance-Strategien und rechtssichere Implementierung',
      'ROI-Analysen und Investitionsplanung für KI-Projekte',
      'Autonome KI-Agenten mit Tool-Sets und Reasoning-Fähigkeiten',
      'Change Management für KI-Adoption in Unternehmen',
      'Cloud- und On-Premise-Strategien (Azure, STACKIT)',
      'Prompting-Engineering und Workflow-Optimierung'
    ]
  },

  technologies: {
    title: 'Technologie-Stack',
    list: 'Python, R, PyTorch, TensorFlow, CUDA, Docker, React, Azure, STACKIT, JupyterLab, Google Colab, Hugging Face, SPSS, Stata'
  },

  clients: {
    title: 'Branchen & Institutionen',
    sectors: [
      'Krankenkassen',
      'Verlage',
      'Banken & Fintech',
      'Industrie & IoT',
      'Forschung & Unis',
      'Beratung',
      'Startups'
    ]
  },

  workshops: {
    title: 'Format-Optionen',
    formats: [
      {
        title: 'Executive Briefing',
        duration: '2-4 Stunden',
        description: 'Strategischer Überblick für Geschäftsführung mit ROI-Fokus und EU AI Act'
      },
      {
        title: 'Management Workshop',
        duration: '1-2 Tage',
        description: 'Projektleiter-Training für KI-Implementierung und Change Management'
      },
      {
        title: 'Technical Deep Dive',
        duration: '2-5 Tage',
        description: 'Hands-on Edge-KI Entwicklung für IT-Teams und Engineers'
      },
      {
        title: 'User Training',
        duration: '0.5-1 Tag',
        description: 'Praktische KI-Anwendung für Fachbereichsmitarbeiter'
      },
      {
        title: 'Individual Coaching',
        duration: 'Nach Bedarf',
        description: 'Persönliche Betreuung und Projektunterstützung'
      }
    ]
  },
  sidebar: {
    languagesLabel: 'Sprachen:',
    languagesValue: 'DE / EN / NL',
    focusLabel: 'Fokus:',
    specializationTitle: 'Spezialisierung',
    specializationItems: [
      'Edge-KI für lokale Datenverarbeitung ohne Cloud-Abhängigkeit',
      'EU AI Act konforme Implementierung für Rechtssicherheit'
    ],
    benefitsTitle: 'Vorteile',
    benefits: [
      'Maßgeschneidert nach Zielgruppe',
      'Sofort umsetzbar',
      'ROI-fokussiert',
      'Remote oder vor Ort'
    ]
  },
  cta: {
    title: 'Bereit für strategische KI-Transformation?',
    description: 'Von Executive-Beratung bis technischer Implementierung - lassen Sie uns Ihre spezifischen Anforderungen besprechen.',
    button: 'Beratung anfragen',
    email: 'info@paioneer.eu',
    subject: 'Trainingsanfrage'
  }
};
